import { render } from "./OrdersManager.vue?vue&type=template&id=30463712"
import script from "./OrdersManager.vue?vue&type=script&lang=js"
export * from "./OrdersManager.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__